export const TIME_OUT = 5000
export const GITHUB_AUTH_BASE_URL = 'https://github.com/login/oauth/authorize'
